/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type DeleteDataExportDestinationSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteDataExportDestinationSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteDataExportDestinationSecurity = {
  option1?: DeleteDataExportDestinationSecurityOption1 | undefined;
  option2?: DeleteDataExportDestinationSecurityOption2 | undefined;
};

/**
 * Destination transport type.
 */
export const DestinationType = {
  Otel: "otel",
} as const;
/**
 * Destination transport type.
 */
export type DestinationType = ClosedEnum<typeof DestinationType>;

export type DeleteDataExportDestinationRequest = {
  /**
   * Destination ID.
   */
  id: string;
  /**
   * Destination transport type.
   */
  destinationType: DestinationType;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteDataExportDestinationSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteDataExportDestinationSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteDataExportDestinationSecurityOption1$Outbound,
    DeleteDataExportDestinationSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteDataExportDestinationSecurityOption1ToJSON(
  deleteDataExportDestinationSecurityOption1:
    DeleteDataExportDestinationSecurityOption1,
): string {
  return JSON.stringify(
    DeleteDataExportDestinationSecurityOption1$outboundSchema.parse(
      deleteDataExportDestinationSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteDataExportDestinationSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteDataExportDestinationSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteDataExportDestinationSecurityOption2$Outbound,
    DeleteDataExportDestinationSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteDataExportDestinationSecurityOption2ToJSON(
  deleteDataExportDestinationSecurityOption2:
    DeleteDataExportDestinationSecurityOption2,
): string {
  return JSON.stringify(
    DeleteDataExportDestinationSecurityOption2$outboundSchema.parse(
      deleteDataExportDestinationSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteDataExportDestinationSecurity$Outbound = {
  Option1?: DeleteDataExportDestinationSecurityOption1$Outbound | undefined;
  Option2?: DeleteDataExportDestinationSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteDataExportDestinationSecurity$outboundSchema: z.ZodMiniType<
  DeleteDataExportDestinationSecurity$Outbound,
  DeleteDataExportDestinationSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteDataExportDestinationSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteDataExportDestinationSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteDataExportDestinationSecurityToJSON(
  deleteDataExportDestinationSecurity: DeleteDataExportDestinationSecurity,
): string {
  return JSON.stringify(
    DeleteDataExportDestinationSecurity$outboundSchema.parse(
      deleteDataExportDestinationSecurity,
    ),
  );
}

/** @internal */
export const DestinationType$outboundSchema: z.ZodMiniEnum<
  typeof DestinationType
> = z.enum(DestinationType);

/** @internal */
export type DeleteDataExportDestinationRequest$Outbound = {
  id: string;
  destination_type: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteDataExportDestinationRequest$outboundSchema: z.ZodMiniType<
  DeleteDataExportDestinationRequest$Outbound,
  DeleteDataExportDestinationRequest
> = z.pipe(
  z.object({
    id: z.string(),
    destinationType: DestinationType$outboundSchema,
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      destinationType: "destination_type",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteDataExportDestinationRequestToJSON(
  deleteDataExportDestinationRequest: DeleteDataExportDestinationRequest,
): string {
  return JSON.stringify(
    DeleteDataExportDestinationRequest$outboundSchema.parse(
      deleteDataExportDestinationRequest,
    ),
  );
}
